import { render, staticRenderFns } from "./ResellerDetails.vue?vue&type=template&id=a1f64b40&scoped=true&"
import script from "./ResellerDetails.vue?vue&type=script&lang=js&"
export * from "./ResellerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ResellerDetails.vue?vue&type=style&index=0&id=a1f64b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f64b40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VCard,VContainer,VForm})
